export default "__VITE_ASSET__CZnlRhi0__"